/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// @ts-ignore
import s from './Loading.css';
// @ts-ignore
import svg from './loading.svg'
class Loading extends React.Component {
  static defaultProps = {
    show: false
  }
  constructor(props){
    super(props)
  }
  render() {
    const show = this.props.show
    let style = {}
    if (!show) {
      style.display = 'none'
    }

    return (
      <div className={s.root} style={style}>
        <div className={s.concent}>
          <div className={s.loadWrapper}>
            <div className={s.loading}>
              <img src={svg} alt=""/>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withStyles(s)(Loading);



// WEBPACK FOOTER //
// src/components/Loading/Loading.js